document.addEventListener('DOMContentLoaded', function () {
    // Add placeholder icons to empty cards
    document.querySelectorAll(".empty-card").forEach((card) => {
        card.innerHTML = `
            <svg viewBox="0 0 50 40" style="width: 50px; height: 40px;">
                <polygon points="5,35 20,15 30,28 35,22 45,35" fill="#bbb"/>
                <circle cx="38" cy="12" r="5" fill="#bbb"/>
            </svg>
        `;
    });

    // Mobile menu toggle
    const hamburger = document.querySelector(".hamburger");
    if (hamburger) {
        hamburger.addEventListener("click", toggleMenu);
    }

    // Close modal when clicking outside
    document.querySelectorAll(".modal").forEach((modal) => {
        modal.addEventListener("click", function (e) {
            if (e.target === this) {
                this.classList.remove("active");
            }
        });
    });

    // Add hover effects via JS (optional if CSS hover isn't enough or for specific logic)
    document.querySelectorAll(".card, .empty-card").forEach((card) => {
        card.addEventListener("mouseenter", function () {
            this.style.boxShadow = "0 5px 15px rgba(0,0,0,0.4)";
        });
        card.addEventListener("mouseleave", function () {
            this.style.boxShadow = "2px 2px 8px rgba(0,0,0,0.3)";
        });
    });
});

// Show specific activity modal
function showActivity(activityName) {
    const modalId = "modal-" + activityName;
    const modal = document.getElementById(modalId);
    if (modal) {
        modal.classList.add("active");
    }
}

// Close specific activity modal
function closeModal(activityName) {
    const modalId = "modal-" + activityName;
    const modal = document.getElementById(modalId);
    if (modal) {
        modal.classList.remove("active");
    }
}

function flipCard() {
    alert("Showing reverse side with training information...");
}

// Toggle mobile menu
function toggleMenu() {
    const navMenu = document.getElementById("navMenu");
    const hamburger = document.querySelector(".hamburger");
    navMenu.classList.toggle("active");
    hamburger.classList.toggle("active");
}

// Mobile Submenu Toggle
document.addEventListener("DOMContentLoaded", function () {
    // Select all links that have a submenu sibling or parent wrapper
    const submenuParents = document.querySelectorAll(".nav .has-submenu > a");

    submenuParents.forEach(function (link) {
        link.addEventListener("click", function (e) {
            // Check if we are on mobile (using the 865px breakpoint as specified in CSS)
            if (window.innerWidth <= 865) {
                const parentLi = this.parentElement;

                // If it is NOT already open, we open it and prevent the link
                if (!parentLi.classList.contains("submenu-open")) {
                    e.preventDefault(); // Stop navigation
                    e.stopPropagation(); // Stop bubbling (good practice here)

                    // Close all OTHER submenus for accordion effect
                    document.querySelectorAll(".nav .has-submenu.submenu-open").forEach(item => {
                        if (item !== parentLi) {
                            item.classList.remove("submenu-open");
                        }
                    });

                    // Open THIS submenu
                    parentLi.classList.add("submenu-open");
                }
                // If it IS already open, we do nothing, allowing the link to proceed.
            }
        });
    });
});

// Implement Real Board Modal functions
function openRealBoardModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
        modal.classList.add("active");
    }
}

function closeRealBoardModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
        modal.classList.remove("active");
    }
}
